import { PageResultOffsetModel } from './page-result-offset-model';

export class PageResultModel<A> extends PageResultOffsetModel<A,number> {
  pageIndex: number;
}
